export const blockIconsHardwareSmartphone = (
	<span className='material-symbols-outlined'>smartphone</span>
);
